import { Component, Input } from '@angular/core';
import { Visit } from '../../models/visit.model';
import { VisitService } from '../../services/visit.service';
import { VisitModalComponent } from '../visit-modal/visit-modal.component';
import { NeighborhoodService } from '../../services/neighborhood.service';
import { AuthService } from '../../services/auth.service';
import { NgbModal, NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Component({
  selector: 'app-visit-list',
  templateUrl: './visit-list.component.html',
  styleUrl: './visit-list.component.scss'
})
export class VisitListComponent {

  @Input() public visits: Visit[] = [];
  @Input() public loading: boolean = true;
  @Input() public neighborhoodId?: string;
  @Input() public enableReports: boolean = false;
  @Input() public moreDetails: boolean = false;

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;

  private readonly maxWeeks = 2;

  constructor(
    public authService: AuthService,
    public formatter: NgbDateParserFormatter,   // public para usarlo en el template
    private calendar: NgbCalendar,
    private modalService: NgbModal,
    public neighborhoodService: NeighborhoodService,
    public visitService: VisitService,
  ) {
    this.toDate   = this.calendar.getToday();
    this.fromDate = this.calendar.getPrev(this.toDate, 'd', this.maxWeeks * 7);
  }

  // ─── Angular lifecycle ────────────────────────────────────────────────────

  ngOnInit() {
    // this.getAll();
  }

  // ─── Custom methods (alphabetical) ───────────────────────────────────────

  // region delete
  /** Solicita confirmación y elimina una visita */
  async delete(visit: Visit) {
    const flag = confirm(`¿Esta seguro que desea borrar la visita de ${visit.fullName}?`);
    if (flag) {
      await this.visitService.delete(this.neighborhoodId!, visit);
    }
  }

  async getAll() {

    console.log(
      this.toIsoString(this.fromDate!),
    );

    console.log(
       this.toIsoString(this.toDate!)
    );
    
    

    await this.visitService.getAll(
      this.neighborhoodId!,
      this.toIsoString(this.fromDate!),
      this.toIsoString(this.toDate!)
    );
  }

  // region isHovered
  /** Devuelve true si la fecha está entre fromDate y el día hover actual */
  isHovered(date: NgbDate): boolean {
    if (!this.fromDate || this.toDate || !this.hoveredDate) return false;
    return date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  // region isInside
  /** Devuelve true si la fecha está dentro del rango seleccionado */
  isInside(date: NgbDate): boolean {
    return this.toDate != null
      && date.after(this.fromDate)
      && date.before(this.toDate);
  }

  // region isRange
  /** Devuelve true si la fecha es parte del rango (extremos incluidos) */
  isRange(date: NgbDate): boolean {
    return (
      date.equals(this.fromDate) ||
      (this.toDate != null && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  // region onDateSelection
  /** Maneja la selección de fechas; limita el rango a maxWeeks semanas */
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;

    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      const maxTo = this.calendar.getNext(this.fromDate, 'd', this.maxWeeks * 7);
      this.toDate  = date.after(maxTo) ? maxTo : date;
      this.getAll();

    } else {
      this.toDate   = null!;
      this.fromDate = date;
    }
  }

  // region open
  /** Abre el modal de detalle de una visita */
  open(visit: Visit) {
    const modalRef = this.modalService.open(VisitModalComponent, { size: 'lg' });
    modalRef.componentInstance.visit = visit;
  }

  // region toIsoString
  /** Convierte NgbDate a string ISO yyyy-MM-dd para usar en el servicio */
  toIsoString(date: NgbDate): string {
    return moment({ year: date.year, month: date.month - 1, day: date.day }).format('YYYY-MM-DD');
  }

  // region validateInput
  /** Valida que el texto ingresado manualmente en el input sea una fecha válida */
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

}